import React, { useEffect, useContext } from 'react';
import { useParams, useHistory } from 'react-router';
import { useSelector } from 'react-redux';

// Hooks
import { useHandleFocusWorkspaceItem } from '../../../hooks/use-handle-focus-workspace-item';

// Utils
import PageUrlsUtil from 'Shared/utils/PageUrls.utils';

// Coontext
import MobileContext from 'Shared/contexts/MobileContext';

// Components
import ActionItems from './ActionItems/ActionItems';
import DiscussionTopics from './DiscussionTopics/DiscussionTopics';

type Props = {
  discussionTopicsTodosContentRef?: {
    current: HTMLDivElement;
  };
  actionItemsTodosContentRef?: {
    current: HTMLDivElement;
  };
  completedTopicsAndItemsContainerRef?: {
    current: HTMLDivElement;
  };
};

function WorkspaceContent({ discussionTopicsTodosContentRef, actionItemsTodosContentRef }: Props) {
  const history = useHistory();
  const { itemUuid, workspaceId } = useParams();
  const isMobile = useContext(MobileContext);

  const needShowCompletedTab = useSelector(state => {
    if (!itemUuid || isMobile) return false;
    const items = [...state.workspace.meeting_items, ...state.workspace.discussion_topics];
    const focusedItem = items.find(({ uuid }) => itemUuid === uuid);
    return !focusedItem || focusedItem?.completed;
  });

  const handleFocusWorkspaceItem = useHandleFocusWorkspaceItem({ workspaceId });

  useEffect(() => {
    if (needShowCompletedTab) history.push(PageUrlsUtil.makeWorkspaceMeetingItemCommentsUrl(workspaceId, itemUuid));
  }, [itemUuid]);

  return (
    <div>
      <DiscussionTopics
        discussionTopicsTodosContentRef={discussionTopicsTodosContentRef}
        onFocusedTodoUpdate={handleFocusWorkspaceItem}
      />

      <ActionItems
        isMobile={isMobile}
        actionItemsTodosContentRef={actionItemsTodosContentRef}
        onFocusedTodoUpdate={handleFocusWorkspaceItem}
      />
    </div>
  );
}

export default React.memo(WorkspaceContent);
